import { Breadcrumb } from "@/components/Breadcrumb";
import { Reveal } from "@/components/Reveal";

// Simple interior-page hero: breadcrumb + eyebrow + H1 + intro.
export const PageHero = ({ eyebrow, h1, intro, breadcrumb, children }) => (
  <section data-testid="page-hero" className="section bg-white pb-10 md:pb-14">
    <div className="container-site">
      {breadcrumb && <Breadcrumb items={breadcrumb} />}
      <Reveal className={breadcrumb ? "mt-8 max-w-[760px]" : "max-w-[760px]"}>
        {eyebrow && <p className="eyebrow">{eyebrow}</p>}
        <h1 data-testid="page-heading" className={eyebrow ? "mt-4" : undefined}>
          {h1}
        </h1>
        {intro && <p className="mt-6 text-lg text-body">{intro}</p>}
        {children}
      </Reveal>
    </div>
  </section>
);
